/**
 * Returns a (fake) value of the given type.
 */
export function placeholder() {
    return undefined;
}
// This library can't use `@types/node` or `lib: dom`
// because they will pollute the global scope
// So `TextEncoder` and `TextDecoder` are not available
// Node.js 8.3 ships `TextEncoder` and `TextDecoder` in `util` module.
// But using top level await to load them requires Node.js 14.1.
// So there is no point to do that. Let's just assume they exist in global.
// @ts-expect-error
const Utf8Encoder = new TextEncoder();
// @ts-expect-error
const Utf8Decoder = new TextDecoder();
export function encodeUtf8(input) {
    return Utf8Encoder.encode(input);
}
export function decodeUtf8(buffer) {
    return Utf8Decoder.decode(buffer);
}
//# sourceMappingURL=utils.js.map